import * as React from 'react'

import { Controller } from 'react-hook-form'

import StruxhubInput from '../../StruxhubInputs/StruxhubInput'
import { TextFieldConfig } from '../types'

interface TextFieldProps {
  field: TextFieldConfig
  control: any
  error?: string
  hideHelperText?: boolean
}

export default function TextField({
  field,
  control,
  error,
  hideHelperText,
}: TextFieldProps) {
  return (
    <Controller
      name={field.name}
      control={control}
      defaultValue={field.defaultValue || ''}
      rules={{
        required: field.required
          ? `${field.label || field.name} is required`
          : false,
      }}
      render={({ field: { onChange, value, name } }) => (
        <StruxhubInput
          label={field.label}
          placeholder={field.placeholder}
          type="text"
          value={value}
          onChange={e => onChange(e.target.value)}
          isRequired={field.required}
          isDisabled={field.disabled}
          isReadOnly={field.readOnly || field.displayOnly}
          isValid={!error}
          validationMessage={error}
          isHelperTextHidden={hideHelperText}
          name={name}
          testId={`resource-field-${field.name}`}
        />
      )}
    />
  )
}
